<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4,9C4,9,12,9,12,9C12.55,9,13,8.55,13,8C13,7.72,12.89,7.47,12.71,7.29C12.71,7.29,8.71,3.29,8.71,3.29C8.530000000000001,3.11,8.280000000000001,3,8,3C7.72,3,7.47,3.11,7.29,3.29C7.29,3.29,3.29,7.29,3.29,7.29C3.11,7.47,3,7.72,3,8C3,8.55,3.45,9,4,9C4,9,4,9,4,9ZM12,10C12,10,4,10,4,10C3.45,10,3,10.45,3,11C3,11,3,12,3,12C3,12.55,3.45,13,4,13C4,13,12,13,12,13C12.55,13,13,12.55,13,12C13,12,13,11,13,11C13,10.45,12.55,10,12,10C12,10,12,10,12,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Eject',
} as DefineComponent
</script>
